import { ReactComponent as IconMyPersona } from "@/assets/svgs/My-persona.svg";
import PropTypes from 'prop-types';
import { featureConstant } from "@/constants/configuration/feature";
import CONSTANTS from "@/public/locales/en/translation.json";
import { feature } from "@/utils/feature-verifier";
import useInfiniteScroll from "@/hooks/use-infiniteScroll/index";
import api from '@/services/api/principal.js'
import { Principal } from "@/hooks/use-principal/index";
import { serializePrincipals } from "./utils";
import { useCallback } from "react";
import Toast from '@/components/Toast';
import LazyLoadWrapper from "../LazyLoad/LazyLoadWrapper";
import LazyLoadableList from "../LazyLoad/LazyLoadableList";

const constants = CONSTANTS.USE_CASE_DETAILS.CURRENT_PARTICIPANTS;

const CurrentParticipants = ({ selectedParticipant }) => {
	const isAgentPrincipalPhase2Enabled = feature(featureConstant.AGENT_PRINCIPAL_PHASE_2);

	const { data: currentPrincipals, isLoading, error, hasMoreData, loadMore, handleSearch, handleSearchCancel, search, toastList, totalCount } = useInfiniteScroll(selectedParticipant?.sharePrincipals ? api : null, serializePrincipals, Principal, { orgId: selectedParticipant?.id });
	const principalListRenderer = useCallback((item) => (
		<>
			<div>{item?.name}</div>
			<p>UEN: {item?.uen}</p>
		</>
	), []);

	return (
		<>
			<div className="current-participant-wrapper">
				<div className="current-participant-container">
					<div className="--with-icon">
						<div
							className="company-logo-name"
							style={{
								backgroundImage: `url(${selectedParticipant?.image})`,
							}}
						></div>
						<div className="--title-wrapper">
							<div className="header">
								{selectedParticipant?.name}
							</div>
						</div>
					</div>
				</div>
				<div className="current-participant-container">
					<div className="-columns">
						<div className="--column-1">
							<div className="header">
								{constants.About_Participants}
							</div>
							<div className="content-grey">
								{selectedParticipant?.description ? selectedParticipant.description : "--"}
							</div>
						</div>
						<div className="--column-2">
							<div className="--column-2">
								<div className="--column-2__row --column-2__row--personas">
									<div className="header">
										{constants.Personas}
									</div>
									{isAgentPrincipalPhase2Enabled ? (
										<div className="layout-dashboard__flex">
											{selectedParticipant?.personas?.map((item) => (
												<div key={item?.id} className="layout-dashboard__persona">
													{item.name}
												</div>
											))}
										</div>
									) : (
										selectedParticipant?.personas?.map((data) => (
											<div key={data?.id} className="persona-list">
												<IconMyPersona />
												<span>{data?.name}</span>
											</div>
										))
									)}
								</div>
							</div>

							{isAgentPrincipalPhase2Enabled && !error && (
								<div className="--column-2__row --column-2__row--principals">
									{selectedParticipant?.sharePrincipals && currentPrincipals && !error &&
										<>
											<div className="header">{constants.Principals}{" "}({totalCount})</div>
											<LazyLoadWrapper
												loadMore={loadMore}
												hasMore={hasMoreData}
												isLoading={isLoading}
												triggerIndex={3}
											>
												<LazyLoadableList
													wrapperClass="current-participants--principals-list__wrapper"
													listClass="current-participants--principals-list__container"
													itemClass="current-participants--principals-list__item"
													testId="current-participants--principals-list"
													items={currentPrincipals}
													renderItems={principalListRenderer}
													isLoading={isLoading}
													searchPlaceholder="Search"
													searchClass="principals-search__input"
													onSearchChange={handleSearch}
													onSearchCancel={handleSearchCancel}
													searchValue={search}
													emptyStateMessage="No principal found"
													showSearch
												/>
											</LazyLoadWrapper>
										</>
									}
								</div>
							)}
							<Toast toastList={toastList} />
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

CurrentParticipants.propTypes = {
	selectedParticipant: PropTypes.shape({
		id: PropTypes.string,
		name: PropTypes.string,
		image: PropTypes.string,
		description: PropTypes.string,
		personas: PropTypes.arrayOf(PropTypes.shape({
			id: PropTypes.string,
			name: PropTypes.string,
			description: PropTypes.string,
			image: PropTypes.string,
			keyvaluedrivers: PropTypes.arrayOf(PropTypes.string)
		})),
		sharePrincipals: PropTypes.bool
	}),
};

export default CurrentParticipants;
